import { Fragment, useEffect, useState } from "react";
import ModalComponent from "../modal";
import InputComponent from "../input";
import CheckboxRadioComponent from "../checkbox-radio";
import SelectDropdownSecondaryComponent from "../select-dropdown-secondary";
import ButtonComponent from "../button";
import { useFormik } from "formik";
import { ruleConfigurationSchema } from "../../helpers/schemas";
// import { useLocation } from "react-router";
import { toast } from "react-toastify";
import { ActionsContainer, FieldContainer, Form, FormError, FormSection, Label, WeightageContainer } from "./add-update-rule-configuration-modal.style";
import moment from "moment";
import SliderComponent from "../slider";
import { Divider } from "@mui/material";
import { useSelector } from "react-redux";
import MultiSelectDropdownComponent from "../multi-select-dropdown";

const AddUpdateRuleConfigurationModal = ({ data, close, label, viewOnly, handleConfigurationSubmit, fromMakerChecker }) => {
    // const location = useLocation();

    // const isChecker = location.pathname.includes('checker');
    // const isDisabledAll = isChecker || viewOnly;

    // console.log('Data from add update rule engine modal', data);

    const { countryList } = useSelector((state) => state.ruleEngineReducer);

    const [hasChanges, setHasChanges] = useState(false);

    const { handleChange, handleBlur, handleSubmit, values, touched, errors, dirty } = useFormik({
        initialValues: {
            scheme: [],
            bins: [],
            ...data,
        },

        validationSchema: ruleConfigurationSchema({ fromMakerChecker }),
        onSubmit: (e) => {
            if (hasChanges) {
                handleConfigurationSubmit(e);
            } else {
                toast.info('No changes found');
            }
        }
    });

    const totalWeightage =
        Number(values.currencyCodeWeitage) +
        Number(values.deviceFingerPrintWeitage) +
        Number(values.numberOfSuccessfullTransactionWeitage) +
        Number(values.purchaseAmountWeitage);

    const handleNumberInput = (e) => {
        // Replace non-digits with empty string
        let value = e.target.value.replace(/[^0-9]/g, '');
        // Remove leading zeros unless the value is just "0"
        value = value.replace(/^0+(?=\d)/, '');
        e.target.value = value;
    };

    const fields = [
        {
            sectionHeading: 'Transaction History',
            label: 'Low Risk Velocity',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Set number of successful transactions',
                    fullCol: true,
                },
                // {
                //     label: 'Lookback Period (days)',
                //     type: 'text',
                //     onInput: handleNumberInput,
                //     placeholder: 'Set no. of days',
                //     name: 'numberOfDaysLow',
                //     value: values?.numberOfDaysLow || '',
                //     // disabled: isDisabledAll,
                // },
                {
                    label: 'Transaction Velocity',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set no. of transactions',
                    name: 'numberOfSuccessfullTransactionLow',
                    value: values?.numberOfSuccessfullTransactionLow || '',
                    // disabled: isDisabledAll,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'numberOfSuccessfullTransactionLowScore',
                    value: values?.numberOfSuccessfullTransactionLowScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            label: 'Medium Risk Velocity',
            fields: [
                // {
                //     label: 'Lookback Period (days)',
                //     type: 'text',
                //     onInput: handleNumberInput,
                //     placeholder: 'Set no. of days',
                //     name: 'numberOfDaysMedium',
                //     value: values?.numberOfDaysMedium || '',
                //     // disabled: isDisabledAll,
                // },
                {
                    label: 'Transaction Velocity',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set no. of transactions',
                    name: 'numberOfSuccessfullTransactionMedium',
                    value: values?.numberOfSuccessfullTransactionMedium || '',
                    // disabled: isDisabledAll,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'numberOfSuccessfullTransactionMediumScore',
                    value: values?.numberOfSuccessfullTransactionMediumScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            label: 'High Risk Velocity',
            fields: [
                // {
                //     label: 'Lookback Period (days)',
                //     type: 'text',
                //     onInput: handleNumberInput,
                //     placeholder: 'Set no. of days',
                //     name: 'numberOfDaysHigh',
                //     value: values?.numberOfDaysHigh || '',
                //     // disabled: isDisabledAll,
                // },
                {
                    label: 'Transaction Velocity',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set no. of transactions',
                    name: 'numberOfSuccessfullTransactionHigh',
                    value: values?.numberOfSuccessfullTransactionHigh || '',
                    // disabled: isDisabledAll,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'numberOfSuccessfullTransactionHighScore',
                    value: values?.numberOfSuccessfullTransactionHighScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            sectionHeading: 'Number Of Days',
            // label: 'Amount Configuration',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Evaluates the recency of user\'s transactions over a specified period.',
                    fullCol: true,
                },
                {
                    label: 'Lookback Period (days)',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set no. of days',
                    name: 'numberOfDaysLow',
                    value: values?.numberOfDaysLow || '',
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            sectionHeading: 'Device Fingerprint',
            // label: 'Amount Configuration',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Set score if device details differ from previous transactions',
                    fullCol: true,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'deviceFingerPrintScore',
                    value: values?.deviceFingerPrintScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            sectionHeading: 'Currency Code',
            // label: 'Amount Configuration',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Set score for transactions made in non-configured currencies',
                    fullCol: true,
                },
                {
                    label: 'Currency',
                    type: 'multiselect',
                    options: countryList?.map(({ currency, currencyCode }) => ({ label: currency, value: currencyCode })),
                    name: 'currencies',
                    value: values?.currencies,
                    // handleCustomChange: (e) => { setFieldValue(`addParticipantBinRangeDto[${index}].currencies`, e?.value) },
                    // disabled: isDisabledAll,
                    // width: 'col3',
                    // error: touched.addParticipantBinRangeDto?.[index]?.currencies && errors.addParticipantBinRangeDto?.[index]?.currencies,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'currencyCodeScore',
                    value: values?.currencyCodeScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            sectionHeading: 'Amount Threshold',
            label: 'Low Amount',
            // label: 'Safe Limit',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Set amount limit',
                    fullCol: true,
                },
                {
                    label: 'Safe Limit',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set safe limit amount',
                    name: 'purchaseAmountLow',
                    value: values?.purchaseAmountLow || '',
                    // disabled: isDisabledAll,
                    helperText: values?.purchaseAmountLow
                        ? `Low limit amount range: 1 to ${values.purchaseAmountLow}`
                        : undefined,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'purchaseAmountLowScore',
                    value: values?.purchaseAmountLowScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            label: 'Medium Amount',
            fields: [
                {
                    label: 'Medium Limit',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set medium limit amount',
                    name: 'purchaseAmountMedium',
                    value: values?.purchaseAmountMedium || '',
                    // disabled: isDisabledAll,
                    helperText: (() => {
                        const low = parseInt(values?.purchaseAmountLow, 10);
                        return values?.purchaseAmountMedium && !isNaN(low)
                            ? `Medium limit amount range: ${low + 1} to ${values.purchaseAmountMedium}`
                            : undefined;
                    })(),
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'purchaseAmountMediumScore',
                    value: values?.purchaseAmountMediumScore || 0,
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            label: 'High Amount',
            fields: [
                {
                    label: 'High Limit',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set high limit amount',
                    name: 'purchaseAmountHigh',
                    value: values?.purchaseAmountHigh || '',
                    // disabled: isDisabledAll,
                    helperText: values?.purchaseAmountHigh && values?.purchaseAmountMedium && !isNaN(parseInt(values.purchaseAmountMedium, 10))
                        ? `High limit amount range: ${parseInt(values.purchaseAmountMedium, 10) + 1} to onwards`
                        : undefined,
                },
                {
                    label: 'Score',
                    type: 'slider',
                    name: 'purchaseAmountHighScore',
                    value: values?.purchaseAmountHighScore || 0,
                    // disabled: isDisabledAll, 
                },
            ],
        },
        {
            sectionHeading: 'Frictionless Score Thresholds',
            // label: 'Amount Configuration',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Configure the threshold for the Frictionless flow',
                    fullCol: true,
                },
                {
                    label: 'Frictionless Score Threshold',
                    type: 'text',
                    onInput: handleNumberInput,
                    placeholder: 'Set frictionless score threshold',
                    name: 'frictionlessScoreThreshold',
                    value: values?.frictionlessScoreThreshold || '',
                    // disabled: isDisabledAll,
                },
            ],
        },
        {
            sectionHeading: 'Rule Activation',
            fields: [
                {
                    type: 'paragraph',
                    text: 'Set the date from which the rule becomes active.',
                    fullCol: true,
                },
                {
                    label: 'Effective Date',
                    type: 'datetime-local',
                    placeholder: 'Set effective date',
                    name: 'effectiveDateTime',
                    value: values?.effectiveDateTime ? moment(values.effectiveDateTime).format('YYYY-MM-DDTHH:mm') : '',
                    min: moment().add(1, 'day').startOf('day').format('YYYY-MM-DDTHH:mm'),
                    // disabled: isDisabledAll,
                },
            ],
        },

        {
            type: 'action',
            actions: [
                { label: 'Cancel', type: 'button', outline: true, action: close },
                { label: 'Save', type: 'submit' },
            ],
            fullCol: true,
        }
    ];

    useEffect(() => {
        setHasChanges(dirty);
    }, [dirty]);

    return (
        <ModalComponent close={close} label={label} width={700} barSlider={true} barSliderValue={totalWeightage}>
            {/* MODAL BODY */}
            <Form onSubmit={handleSubmit}>
                {
                    fields && fields.length > 0 && fields.map((section, index) => (
                        <FormSection key={index}>
                            {
                                section?.sectionHeading &&
                                <>
                                    <Divider><h5>{section?.sectionHeading}</h5></Divider>
                                    {/* <h4>{section?.sectionHeading}</h4> */}
                                    {
                                        section?.fields && section?.fields.length > 0 && section?.fields.map((field, subIndex) => (
                                            <Fragment key={subIndex}>
                                                {
                                                    field.type === 'paragraph' && !field.hide &&
                                                    <FieldContainer>
                                                        <p>{field.text}</p>
                                                    </FieldContainer>

                                                }
                                            </Fragment>
                                        ))}
                                    {
                                        !['Number Of Days', 'Rule Activation'].includes(section?.sectionHeading) && (
                                            <WeightageContainer>
                                                {section?.sectionHeading === 'Currency Code' && (
                                                    <>
                                                        <input
                                                            type="number"
                                                            name="currencyCodeWeitage"
                                                            value={values.currencyCodeWeitage || ''}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            placeholder="Weightage"
                                                            style={{
                                                                width: '60%',
                                                                padding: '6px 10px',
                                                                border: errors.currencyCodeWeitage && touched.currencyCodeWeitage ? '1px solid red' : '1px solid #ccc',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                boxSizing: 'border-box',
                                                                outline: 'none',
                                                                background: '#fff',
                                                                color: '#222',
                                                                transition: 'border-color 0.2s',
                                                            }}
                                                        />
                                                        {errors.currencyCodeWeitage && touched.currencyCodeWeitage && (
                                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                                {errors.currencyCodeWeitage}
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {section?.sectionHeading === 'Device Fingerprint' && (
                                                    <>
                                                        <input
                                                            type="number"
                                                            name="deviceFingerPrintWeitage"
                                                            value={values.deviceFingerPrintWeitage || ''}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            placeholder="Weightage"
                                                            style={{
                                                                width: '60%',
                                                                padding: '6px 10px',
                                                                border: errors.deviceFingerPrintWeitage && touched.deviceFingerPrintWeitage ? '1px solid red' : '1px solid #ccc',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                boxSizing: 'border-box',
                                                                outline: 'none',
                                                                background: '#fff',
                                                                color: '#222',
                                                                transition: 'border-color 0.2s',
                                                            }}
                                                        />
                                                        {errors.deviceFingerPrintWeitage && touched.deviceFingerPrintWeitage && (
                                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                                {errors.deviceFingerPrintWeitage}
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {section?.sectionHeading === 'Transaction History' && (
                                                    <>
                                                        <input
                                                            type="number"
                                                            name="numberOfSuccessfullTransactionWeitage"
                                                            value={values.numberOfSuccessfullTransactionWeitage || ''}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            placeholder="Weightage"
                                                            style={{
                                                                width: '60%',
                                                                padding: '6px 10px',
                                                                border:
                                                                    errors.numberOfSuccessfullTransactionWeitage && touched.numberOfSuccessfullTransactionWeitage
                                                                        ? '1px solid red'
                                                                        : '1px solid #ccc',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                boxSizing: 'border-box',
                                                                outline: 'none',
                                                                background: '#fff',
                                                                color: '#222',
                                                                transition: 'border-color 0.2s',
                                                            }}
                                                        />
                                                        {errors.numberOfSuccessfullTransactionWeitage && touched.numberOfSuccessfullTransactionWeitage && (
                                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                                {errors.numberOfSuccessfullTransactionWeitage}
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {section?.sectionHeading === 'Amount Threshold' && (
                                                    <>
                                                        <input
                                                            type="number"
                                                            name="purchaseAmountWeitage"
                                                            value={values.purchaseAmountWeitage || ''}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            placeholder="Weightage"
                                                            style={{
                                                                width: '60%',
                                                                padding: '6px 10px',
                                                                border: errors.purchaseAmountWeitage && touched.purchaseAmountWeitage ? '1px solid red' : '1px solid #ccc',
                                                                borderRadius: '6px',
                                                                fontSize: '14px',
                                                                boxSizing: 'border-box',
                                                                outline: 'none',
                                                                background: '#fff',
                                                                color: '#222',
                                                                transition: 'border-color 0.2s',
                                                            }}
                                                        />
                                                        {errors.purchaseAmountWeitage && touched.purchaseAmountWeitage && (
                                                            <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                                                                {errors.purchaseAmountWeitage}
                                                            </div>
                                                        )}
                                                    </>
                                                )}

                                                {/* Show total weightage error (from Yup .test) if total > 100 */}
                                                {errors.totalWeightage && (
                                                    <div style={{ color: 'red', fontSize: '12px', marginTop: '6px' }}>
                                                        {errors.totalWeightage}
                                                    </div>
                                                )}
                                            </WeightageContainer>
                                        )
                                    }

                                </>
                            }
                            <h6>{section?.label}</h6>
                            {
                                section?.fields && section?.fields.length > 0 && section?.fields.map((field, subIndex) => (
                                    <Fragment key={subIndex}>
                                        {
                                            ['text', 'number', 'date', 'datetime-local'].includes(field.type) && !field.hide &&
                                            <FieldContainer $fullcol={field.fullCol}>
                                                {/* <Label>{field.label}</Label> */}
                                                <InputComponent
                                                    type={field.type}
                                                    onInput={field.onInput}
                                                    label={field.label}
                                                    placeholder={field.placeholder}
                                                    onBlur={handleBlur}
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={handleChange}
                                                    min={field.min}
                                                    disabled={field.disabled}
                                                    helperText={field.helperText}
                                                    mui
                                                />
                                                {
                                                    touched[field.name] && errors[field.name] && (
                                                        <FormError>{errors[field.name]}</FormError>
                                                    )
                                                }
                                            </FieldContainer>
                                        }

                                        {
                                            ['checkbox', 'radio'].includes(field.type) && !field.hide &&
                                            <FieldContainer $fullcol={field.fullCol}>
                                                <Label>{field.label}</Label>
                                                <CheckboxRadioComponent
                                                    type={field.type}
                                                    label={field.innerLabel}
                                                    name={field.name}
                                                    checked={field.value}
                                                    onChange={handleChange}
                                                    disabled={field.disabled}
                                                />
                                                {
                                                    touched[field.name] && errors[field.name] && (
                                                        <FormError>{errors[field.name]}</FormError>
                                                    )
                                                }
                                            </FieldContainer>
                                        }

                                        {
                                            field.type === 'select' && !field.hide &&
                                            <FieldContainer $fullcol={field.fullCol}>
                                                <Label>{field.label}</Label>
                                                <SelectDropdownSecondaryComponent
                                                    options={field.options}
                                                    name={field.name}
                                                    value={field.value}
                                                    onChange={handleChange}
                                                    disabled={field.disabled}
                                                />
                                                {
                                                    touched[field.name] && errors[field.name] && (
                                                        <FormError>{errors[field.name]}</FormError>
                                                    )
                                                }
                                            </FieldContainer>
                                        }

                                        {
                                            field.type === 'multiselect' && !field.hide &&
                                            <FieldContainer $fullcol={field.fullCol}>
                                                {/* <Label>{field.label}</Label> */}
                                                <MultiSelectDropdownComponent
                                                    key={field.value}
                                                    label={field.label}
                                                    options={field.options}
                                                    name={field.name}
                                                    value={field.value}
                                                    // onChange={(e) => { handleChange(e); field.handleCustomChange && field.handleCustomChange(e.target) }}
                                                    onChange={handleChange}
                                                    disabled={field.disabled}
                                                    mui
                                                />
                                                {
                                                    touched[field.name] && errors[field.name] && (
                                                        <FormError>{errors[field.name]}</FormError>
                                                    )
                                                }
                                            </FieldContainer>
                                        }

                                        {
                                            field.type === 'slider' && !field.hide &&
                                            <FieldContainer $fullcol={field.fullCol}>
                                                <Label>{field.label}</Label>
                                                <SliderComponent
                                                    name={field.name}
                                                    value={values[field.name] || 0}
                                                    onChange={(val) => {
                                                        const event = { target: { name: field.name, value: String(val) } };
                                                        handleChange(event);
                                                    }}
                                                    min={0}
                                                    max={100}
                                                // step={5}
                                                />
                                                {/* <small>{values[field.name] || 0}%</small> */}

                                                {
                                                    touched[field.name] && errors[field.name] && (
                                                        <FormError>{errors[field.name]}</FormError>
                                                    )
                                                }
                                            </FieldContainer>
                                        }

                                        {/* {
                                field.type === 'select' && !field.hide &&
                                <FieldContainer $fullcol={field.fullCol}>
                                    <Label>{field.label}</Label>
                                    <SelectDropdownComponent
                                        options={field.options}
                                        name={field.name}
                                        value={field.value}
                                        onChange={(e) => { handleChange(e); handleFormChange(e) }}
                                        disabled={field.disabled}
                                    />
                                    {
                                        touched[field.name] && errors[field.name] && (
                                            <FormError>{errors[field.name]}</FormError>
                                        )
                                    }
                                </FieldContainer>
                            } */}
                                    </Fragment>
                                ))
                            }
                            {
                                section.type === 'action' && section.actions.length > 0 &&
                                <FieldContainer $fullcol={section.fullCol}>
                                    <ActionsContainer>
                                        {
                                            section.actions.map((button, index) => (
                                                <ButtonComponent
                                                    key={index}
                                                    label={button.label}
                                                    type={button.type}
                                                    outline={button.outline}
                                                    color={button.color}
                                                    {...(button.action && { onClick: button.action })}
                                                />
                                            ))
                                        }
                                    </ActionsContainer>
                                </FieldContainer>
                            }
                        </FormSection>
                    ))
                }
            </Form>
        </ModalComponent>
    );
};

export default AddUpdateRuleConfigurationModal;